module.exports = __webpack_public_path__ + "img/jzgicon.197684e2.svg";